import { z } from "zod";
import {
  AD_BASIC_UNLIMITED_PACKAGE_CONFIG,
  AD_PACKAGE_CONFIGS,
  AdPackageConfig,
} from "./AdPackageConfig";
import { AdProductKey } from "../schema/AdProductKey";
import { AD_UPGRADE_CONFIGS, AdUpgradeConfig } from "./AdUpgradeConfig";
import _ from "lodash";
import { AdPricingModel } from "../../AdConfigState";

export const AD_PRODUCT_TYPE_SCHEMA_KEYS = ["PACKAGE", "UPGRADE"] as const;

export const AD_PRODUCT_TYPE_SCHEMA = z.enum(AD_PRODUCT_TYPE_SCHEMA_KEYS);

export type AdProductType = z.infer<typeof AD_PRODUCT_TYPE_SCHEMA>;

export interface AdProductConfigBase {
  type: AdProductType;
  key: AdProductKey;
  title: string;
  description: string;
}

export type AdProductConfig = AdUpgradeConfig | AdPackageConfig;

const AD_PRODUCT_CONFIGS: Record<AdProductKey, AdProductConfig> = {
  ...AD_PACKAGE_CONFIGS,
  ...AD_UPGRADE_CONFIGS,
};

const AD_PRODUCT_CONFIG_LIST: AdProductConfig[] =
  Object.values(AD_PRODUCT_CONFIGS);

export function GetAllProductConfigs({
  pricing,
}: {
  pricing: AdPricingModel;
}): AdProductConfig[] {
  const standardProducts = _.cloneDeep(AD_PRODUCT_CONFIG_LIST);
  if (pricing === "free_basic") {
    return [
      AD_BASIC_UNLIMITED_PACKAGE_CONFIG,
      ...standardProducts.filter((product) => product.key !== "BASIC"),
    ];
  }
  return standardProducts;
}